import { testimonials } from '@/mocks/categories';

export default function TestimonialSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-accent-400"></span>
            <span className="text-xs font-semibold uppercase tracking-widest text-foreground-500">Community Reviews</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Trusted by Shoppers Worldwide
          </h2>
          <p className="text-base text-foreground-600 max-w-xl mx-auto">
            Real feedback from CSSBuy spreadsheet users around the world
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-6 md:p-7 border border-background-200/70"
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-secondary-500 text-sm"></i>
                ))}
              </div>
              <h4 className="text-base font-heading font-semibold text-foreground-900 mb-3">
                &ldquo;{t.name.split(' ')[0]}&apos;s Review&rdquo;
              </h4>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                {t.content}
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/70">
                <div className="w-9 h-9 rounded-full bg-accent-200 flex items-center justify-center">
                  <span className="text-xs font-bold text-accent-700">{t.name.charAt(0)}</span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-800">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}